// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__F-H9w","icon":"SortAdornment_icon__u8ybT","up":"SortAdornment_up__2SP32","down":"SortAdornment_down__3jq29","active":"SortAdornment_active__1UoBJ"};